import { Meta } from '@/src/components/common/Meta';
import UserProfileCreateUnifiedProfile from '@/src/components/game/Account/UserProfileCreateUnifiedProfile';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const CreateProfilePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t(i18nKeys.meta.createProfile.title)} />
      <UserProfileCreateUnifiedProfile />
    </>
  );
};
